import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { ACTIVE_PRIORITY_TASKS_QUERY } from '../graphql/queries'
import { FETCH_ACTIVE_PRIORITY_TASKS } from '../redux/action-types'

const useActivePriorityTasksLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    isActiveTaskLoading: isLoading,
    activeTaskError: error,
    activeTasks: data,
  } = useSelector(store => store.priorityTasks.priorityTask)

  const fetch = useCallback(
    () =>
      apolloService.query({
        query: ACTIVE_PRIORITY_TASKS_QUERY,
        dispatch,
        action: FETCH_ACTIVE_PRIORITY_TASKS,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useActivePriorityTasksLazyQuery
